import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { navGuard, authGuard } from '@/utils/Gaurd'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { urlPath } from '@/utils'
import store from '../store'

// auth
import { routes as authRoutes } from '@/router/auth'
// main
import { routes as mainRoutes } from '@/router/main'
// master
import { routes as masterRoutes } from '@/router/master'

Vue.use(VueRouter)

// combine routes
const routes: Array<RouteConfig> = [
  ...authRoutes,
  {
    ...urlPath.HOME,
    component: () =>
      import(/* webpackChunkName: "home" */ '../pages/Home/index.vue')
  },
  ...mainRoutes,
  ...masterRoutes
]


// create router
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
let pendingNavigation: string | null = null

router.afterEach((to, _from) => {
  store.commit('setLoadingIndicator', false)
  // createAccessLogs(from, to)
  const reloadKey = `chunk_reload:${to.fullPath}`
  sessionStorage.removeItem(reloadKey)
})
router.beforeEach(navGuard)
router.beforeEach(authGuard)
// Must be last so pendingNavigation reflects the guards' final resolved destination
router.beforeEach((to, from, next) => {
  pendingNavigation = to.fullPath
  next()
})
router.onError((error) => {
  const isChunkError =
    error.name === 'ChunkLoadError' ||
    error.message.includes('ChunkLoadError') ||
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed') ||
    /Loading chunk \d+ failed/.test(error.message) ||
    error.message.includes('Loading CSS chunk')

  if (isChunkError && pendingNavigation) {
    const reloadKey = `chunk_reload:${pendingNavigation}`
    try {
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, '1')
        window.location.assign(pendingNavigation)
      }
    } catch {
      window.location.assign(pendingNavigation)
    }
  }
})

export default router
